/**
 * @file clamp.ts
 * @role Tiny shared numeric clamps. One home for the 0..1 "unit" clamp used by volumes,
 *       slider values, alphas, etc., so each consumer doesn't reinvent it.
 * @owns clamp() + clamp01().
 * @reads Nothing.
 * @neverDoes Touch Pixi. Decide outcomes.
 */
export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

/** Clamp to the [0, 1] unit range. */
export function clamp01(value: number): number {
  return clamp(value, 0, 1);
}
